import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Avatar, AvatarImage } from '@fiverr-private/avatar';
import { Text } from '@fiverr-private/typography';
import { AppI18n } from '../../../utils/i18n';
import { AdminMember } from '../../../types';

interface AdminBlockProps {
    admin: AdminMember;
}

export const AdminBlock = ({ admin }: AdminBlockProps) => {
    const adminName = admin.name || admin.username;

    return (
        <Stack justifyContent="flexStart" alignItems="center">
            <Avatar size="md" username={admin.username} displayName={adminName}>
                {admin.imageUrl && <AvatarImage alt={admin.username} src={admin.imageUrl} />}
            </Avatar>
            <Stack gap="1" direction="column">
                <Text size="b_md">
                    <AppI18n k="request_upgrade_modal.account_admin" params={{ adminName }} />
                </Text>
                <Text color="bodySecondary" size="b_sm">
                    {admin.email}
                </Text>
            </Stack>
        </Stack>
    );
};
